import React, { Fragment, useState } from 'react';
import cn from '../../../../lib/bem/index';
import HeaderLogoComponent from '../headerLogo/headerLogo_Component';
import MenuStepperComponent from '../menuStepper/menuStepper_Component';
import HeaderTitleComponent from '../headerTitleMobil/headerTitleMobil_Component';
import ico_rightSidebar from '../../../../assets/svg/ico_rightSidebar.svg';
import LoadingComponent from '../../../../components/Loading/loading_component';
import ButtonFlotanteComponent from './../../../../components/buttonFlotante/buttonFlotante_component';
import ModalConfirmarDatosComponent from './../modalConfirmarDatos/modalConfirmarDatos_Component';

import './layoutSimulador_Component.scss';
import ModalConfirmarDatosExito from '../modalConfirmarDatosExito/modalConfirmarDatosExito_Component';

const LayoutSimuladorComponent = (props) => {
  const classes = cn('layoutSimuladorComponent');
  const [mostrarModal, setMostrarModal] = useState(false);
  const [mostrarSuccessMessage, setMostrarSuccessMessage] = useState(false);

  return (
    <Fragment>
      {props.laoding ? <LoadingComponent /> : null}
      {mostrarModal && !mostrarSuccessMessage ? (
        <ModalConfirmarDatosComponent
          mostrarSuccessMessage={setMostrarSuccessMessage}
          onClose={() => setMostrarModal(false)}
        />
      ) : null}

      {mostrarSuccessMessage ? (
        <ModalConfirmarDatosExito
          onClose={() => {
            setMostrarModal(false);
            setMostrarSuccessMessage(false);
          }}
        />
      ) : null}
      <div className={classes()}>
        <div className={'layoutSimuladorComponentLayout'}>
          <div>
            <HeaderLogoComponent />
            <HeaderTitleComponent
              title={props.title}
              desc={props.desc}
              infoNro={props.info}
              indice={props.indice}
            />
            <div className={'layoutSimuladorComponentRow'}>
              <MenuStepperComponent
                onClickRegresar={props.action}
                indice={props.indice}
              />
              {props.body}
            </div>
          </div>
          <div className={'layoutSimuladorComponentRight'}>
            <img src={ico_rightSidebar} alt="ico_rightSidebar" />
          </div>
        </div>
      </div>
      <ButtonFlotanteComponent mostrarModal={setMostrarModal} />
    </Fragment>
  );
};

export default LayoutSimuladorComponent;
